export default "__VITE_ASSET__DC0Gf4Ns__"